import {ActionReducerMap, createFeatureSelector} from '@ngrx/store';
import {AppState} from '../../core/store/core.state';

import {chacrasReducer} from './entities/shared/chacras/chacras.reducer';
import {ChacrasState} from './entities/shared/chacras/chacras.state';
import {chacrasGeoReducer} from './entities/shared/chacras-geo/chacras-geo.reducer';
import {ChacrasGeoState} from './entities/shared/chacras-geo/chacras-geo.state';
import {dibujosReducer} from './entities/shared/dibujos/dibujos.reducer';
import {DibujosState} from './entities/shared/dibujos/dibujos.state';
import {personasReducer} from './entities/shared/personas/personas.reducer';
import {PersonasState} from './entities/shared/personas/personas.state';
import {empresasReducer} from './entities/shared/empresas/empresas.reducer';
import {EmpresasState} from './entities/shared/empresas/empresas.state';
import {rolesReducer} from './entities/shared/roles/roles.reducer';
import {RolesState} from './entities/shared/roles/roles.state';
import {rolesArcgisReducer} from './entities/shared/roles-arcgis/roles-arcgis.reducer';
import {RolesArcgisState} from './entities/shared/roles-arcgis/roles-arcgis.state';
import {UIState} from './ui/ui-state';
import {uiReducer} from './ui/ui.reducer';
import {adjuntosReducer} from "./entities/shared/adjuntos/adjuntos.reducer";
import {AdjuntosState} from "./entities/shared/adjuntos/adjuntos.state";
import {mensajesReducer} from "./entities/shared/mensajes/mensajes.reducer";
import {MensajesState} from "./entities/shared/mensajes/mensajes.state";
import {suelosReducer} from "./entities/shared/suelos/suelos.reducer";
import {SuelosState} from "./entities/shared/suelos/suelos.state";
import {cultivosReducer} from "./entities/shared/cultivos/cultivos.reducer";
import {CultivosState} from "./entities/shared/cultivos/cultivos.state";
import {zonasExclusionReducer} from "./entities/shared/zonas-exclusion/zonas-exclusion.reducer";
import {ZonasExclusionState} from "./entities/shared/zonas-exclusion/zonas-exclusion.state";
import {ingenierosAgronomosReducer} from "./entities/shared/ingenieros-agronomos/ingenieros-agronomos.reducer";
import {IngenierosAgronomosState} from "./entities/shared/ingenieros-agronomos/ingenieros-agronomos.state";

export const FEATURE_NAME = 'features';
export const selectFeatures = createFeatureSelector<State, FeaturesState>(FEATURE_NAME);

export const reducers: ActionReducerMap<FeaturesState> = {
  ui: uiReducer,
  chacras: chacrasReducer,
  chacrasGeo: chacrasGeoReducer,
  dibujos: dibujosReducer,
  personas: personasReducer,
  empresas: empresasReducer,
  ingenierosAgronomos: ingenierosAgronomosReducer,
  adjuntos: adjuntosReducer,
  mensajes: mensajesReducer,
  suelos: suelosReducer,
  cultivos: cultivosReducer,
  zonasExclusion: zonasExclusionReducer,
  roles: rolesReducer,
  rolesArcgis: rolesArcgisReducer,
};

export interface FeaturesState {
  ui: UIState;
  chacras: ChacrasState;
  chacrasGeo: ChacrasGeoState;
  dibujos: DibujosState;
  personas: PersonasState;
  empresas: EmpresasState;
  ingenierosAgronomos: IngenierosAgronomosState;
  adjuntos: AdjuntosState;
  mensajes: MensajesState,
  suelos: SuelosState,
  cultivos: CultivosState,
  zonasExclusion: ZonasExclusionState;
  roles: RolesState;
  rolesArcgis: RolesArcgisState;
}


export interface State extends AppState {
  features: FeaturesState
}
